import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteLabourItemGroup } from '../api/labourItemGroupsApi';
import { labourGroupKeys } from './labourGroupKeys';

/**
 * Mutation hook for deleting labour item groups.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export const useDeleteGroupMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (groupId: string) => {
      await deleteLabourItemGroup(groupId);
    },
    onSuccess: () => {
      // Invalidate all labour group queries to ensure UI consistency
      queryClient.invalidateQueries({ queryKey: labourGroupKeys.all });
    },
  });
};
